/**
 * Custom hook using for logout.
 * It dispathes action from usersSlice.js and call confirmation popup.
 */

//react and redux
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setUser } from "../features/users/usersSlice";

//firebase
import { signOut } from "firebase/auth";
import { auth } from "../app/firebase";

export const useLogoutModal = () => {
    
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const openModal = () => setOpen(true);
    const closeModal = () => setOpen(false);

    const confirmLogout = () => {
        signOut(auth)
        .then(() => {
            dispatch(setUser(null));
            closeModal();
        })
        .catch((error) => {
            console.error("Logout error:", error);
            closeModal();
        });
    };

    return {
        open,
        openModal,
        closeModal,
        confirmLogout,
    };
};
